import React from 'react'

import PropTypes from 'prop-types'

import ImageSlider, {IMAGE_SLIDER_COUNTER_POSITIONS} from '@s-ui/react-image-slider'

const SLIDER_WRAPPER = 'slider-wrapper'

export default function TechnicalDetailsSlider({images = []}) {
  const sliderOptions = {
    isFullHeight: true,
    imageObjectFit: 'contains',
    isFullWidth: false
  }

  const hasMultipleImages = Boolean(images.length > 1)

  return (
    <div className="mt-TechnicalDetailsSlider" data-testid={SLIDER_WRAPPER}>
      <ImageSlider
        images={images}
        enableCounter={hasMultipleImages}
        counterPosition={IMAGE_SLIDER_COUNTER_POSITIONS.BOTTOM_CENTER}
        sliderOptions={sliderOptions}
      />
    </div>
  )
}

TechnicalDetailsSlider.displayName = 'TechnicalDetailsSlider'
TechnicalDetailsSlider.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired
}
